import { SymbolsRequestParams, SymbolsResponse } from './types';

const url = 'https://benchmarks.pyth.network/v1/shims/tradingview/symbols';

export const getSymbolsFetcher = async ({
  symbol,
}: SymbolsRequestParams): Promise<SymbolsResponse> => {
  const _url = `${url}?symbol=${symbol}`;
  const res = await fetch(_url);
  const response = (await res.json()) as SymbolsResponse;

  return response;
};
